import store from '@/store'
import utils from '@/js/utils'
import { resolveMaterial } from '@/js/MaterialResolver'

function normaliseSlot(slotOrValue) {
  if (!slotOrValue) return null
  const slot = typeof slotOrValue === 'string' ? { value: slotOrValue } : { ...slotOrValue }
  if (slot.materialId) return slot
  if (typeof slot.value === 'string') {
    let v = slot.value.split('Jumbo')[0]
    v = v.split('New')[0]
    if (v === 'fenix') v = 'fenixNtm'
    slot.value = v
  }
  return slot
}

export default class Materials {
  static getProperties(material) {
    const type = store.state.materials?.find((type) => {
      return type.value === material.material
    })

    if (!type) return null

    let typeColourIndex = type.colours?.findIndex((colour) => colour.value === material.colourCode)

    type.colour = type.colours[typeColourIndex]

    return type
  }

  static getSheetCostFromProperties(slotOrValue, w, h, thickness, sides) {
    const slot = normaliseSlot(slotOrValue)
    // Swap width/height of legacy materials (long side first)
    if (h > w) {
      h = [w, (w = h)][0]
    }

    const materialType = resolveMaterial(slot)

    if (!materialType) {
      console.error('Material not found', slot && slot.value, w, h, thickness)
      return false
    }

    const size = materialType.sizes.find((size) => {
      if (materialType.hasGrain) {
        return size.w === w && size.h === h && size.thickness === thickness
      } else {
        return size.w === w && size.h === h && size.thickness === thickness && size?.sides === sides
      }
    })

    if (!size) {
      return false
    }

    return utils.toFixedNumber(size.cost, 2)
  }

  static getSheetSizesForType(slotOrValue) {
    return resolveMaterial(normaliseSlot(slotOrValue))
  }

  static getMaterialsByRegion(region) {
    return store.state.materials?.filter((m) => {
      return m.regions.includes(region)
    })
  }

  static getWorktopsByRegion(region) {
    return store.state.worktops?.filter((w) => {
      const regions = w.regions || (w.region ? [w.region] : [])
      return regions.includes(region)
    })
  }

  static hasGrain(slotOrValue) {
    const material = resolveMaterial(normaliseSlot(slotOrValue))
    return material ? material.hasGrain : null
  }

  static getNameFromValue(slotOrValue) {
    const material = resolveMaterial(normaliseSlot(slotOrValue))
    return material ? material.text : undefined
  }

  static getColoursFromValue(slotOrValue) {
    if (!slotOrValue) return []
    const material = resolveMaterial(normaliseSlot(slotOrValue))
    return material ? material.colours : []
  }
}
